import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  Link
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as DialogCheck } from "../assets/images/dialog-check.svg";
import CloseIcon from "../assets/images/plus-circle-fill.svg";
import { Link as RouterLink, useNavigate } from 'react-router-dom';


const DialogSend = (props) => {
  const handleClose = () => {
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => {return false}}
        open={props.open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} pt={4}>
            <DialogCheck></DialogCheck>
            <Typography color="primary" variant="h3" mt={3}>ส่งอนุมัติสำเร็จ</Typography>
            <Typography textAlign="center" mt={2}>{props.text}<br />ได้ที่หน้า กล่องข้อความ</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
            <Link
              component={RouterLink}
              to="/app/inbox"
            >
            <Button size="large" variant="contained" sx={{ width: '300px' }}>
              ไปที่หน้ากล่องข้อความ
            </Button>
            </Link>
          <Typography color="#A0A0A0" variant="label" mt={2} sx={{textDecoration: "underline", cursor: "pointer"}} onClick={handleClose}>ปิด</Typography>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default DialogSend;
